<template lang="pug">
    .photo-report(v-if="content")
        .photo-report__title
            h2.photo-report__title-name {{ content.name }}
            .photo-report__title-wr /
            .photo-report__title-date {{ content.date }}
        router-link.photo-report__link(to="/fotootchyoty")
            SvgIcon.photo-report__link-icon(name="arrow" width="10" height="18")
            .photo-reports-item__link-text Назад к событиям
        .photo-report__block
            .photo-report__list
                .photo-report__list-item(v-for="item in content.photoReport" :key="item.id")
                    a.photo-report__list-item-link(:href='item.imgBig.path' :data-src='item.imgBig.path'  data-fancybox="gallery")
                        .photo-report__list-item-img-wr
                            img.photo-report__list-item-img(:src="item.imgPrev.path" :alt="item.imgPrev.name"  :class="{'photo-report__list-item-img--hide': imgHide}")
            .photo-report__button-wr(v-if="!reportEnd")
                button.photo-report__button(type="button" @click="loadNextItems()") Муу...
                MinPreloader
            .photo-report__top.photo-report__top--hide(@click="scrollTop()")
                SvgIcon(name="top" width="40" height="60")
</template>

<script>
    // @ is an alias to /src
    import '@/components/common/photoReport/photoReport.styl';
    import EventBus from '@/eventBus';
    import MinPreloader from '@/components/common/minPreloader/MinPreloader.vue';

    import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
    import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

    export default {
        name: 'PhotoReport',
        mixins: [AjaxHelpersVue],

        data() {
            return {
                content: null,
                objImages: [],
                imgHide: true,
                scrollbar: null,
                countItemsOfPage: 0,
                maxItemsForScrollBar: 4,
                reportEnd: false,
                path: null,
                type: null,
                reportList: null,
                positionOnPage: 0,
            }
        },

        components: {
            SvgIcon,
            MinPreloader,
        },

        created() {
            EventBus.$on('loadPhotoReportPage', params => {
                this.content = null;
                let url = params.url.split('/');
                this.request(params, '/'+url[1]);
            });

            EventBus.$on('imgLoaded', (res) => {
                this.imgHide = res;
            });
        },

        mounted() {
            let windowWidth = $(window).innerWidth();
            let windowHeight = $(window).innerHeight();
            if(windowWidth > 1200 && windowHeight > 750) {
                this.maxItemsForScrollBar = 8;
            }
            if(windowWidth > 1600) {
                this.maxItemsForScrollBar = 4;
            }
            if(windowWidth > 1900) {
                this.maxItemsForScrollBar = 8;
            }
        },

        methods: {
            request(url, link) {
                this.req('PhotoReportsPage:getPhotoReportsPage', {url: link}, res => {
                    this.path = link;
                    this.type = url.type;
                    let data = {
                        url: link,
                        type: url.type,
                        count: $('.photo-report__list-item').length
                    };
                    EventBus.$emit('setMenuTopActiveClass', url.url, url.from);
                    this.innerRequest('PhotoReportsPage:getPhotoReportList', data).then(response => {
                        EventBus.$emit('pagePreloaderHide');
                        if(response.status === '404') {
                            this.$router.push('/404');
                        } else {
                            this.content = response;
                            this.reportEnd = response.end;
                            for (let i = 0; i < this.content.photoReport.length; i++) {
                                this.objImages = this.objImages.concat({
                                    loaded: false,
                                    url: this.content.photoReport[i].imgPrev.path
                                });
                            }
                            this.$nextTick(() => {
                                this.countItemsOfPage = $('.photo-report__list-item').length;
                                if (this.countItemsOfPage <= this.maxItemsForScrollBar) {
                                    $('.samedia').removeClass('samedia--hide');
                                    $('.footer').removeClass('footer--hide');
                                    $('.page__decore--12').removeClass('page__decore--hide-bottom');
                                    $('.page__decore--11').removeClass('page__decore--hide-bottom');
                                    $('.page__decore--10').removeClass('page__decore--hide-bottom');
                                } else {
                                    $('.page__decore--12').addClass('page__decore--hide-bottom');
                                    $('.page__decore--11').addClass('page__decore--hide-bottom');
                                    $('.page__decore--40').addClass('page__decore--hide-bottom');
                                }
                                this.checkImgLoading(this.objImages);
                                this.buttonTopAnimationEvents();
                                this.fancyboxInit();
                            });
                        }
                    });
                }, 'photo-report');
            },

            loadNextItems() {
                if(!this.reportEnd) {
                    EventBus.$emit('pagePreloaderShow');
                    $('.photo-report__list').addClass('photo-report__list--loading');
                    $('.min-preloader__bell').addClass('min-preloader__bell--show');
                    $('.samedia').addClass('samedia--hide');
                    $('.footer').addClass('footer--hide');
                    let data = {
                        url: this.path,
                        type: this.type,
                        count: $('.photo-report__list-item').length
                    };
                    this.innerRequest('PhotoReportsPage:getPhotoReportList', data).then(response => {
                        this.content.photoReport = this.content.photoReport.concat(response.photoReport);
                        this.reportEnd = response.end;
                        this.$nextTick(() => {
                            $('.photo-report__list').removeClass('photo-report__list--loading');
                            $('.min-preloader__bell').removeClass('min-preloader__bell--show');
                            $('.min-preloader__bell').removeClass('min-preloader__bell--show');
                            EventBus.$emit('pagePreloaderHide');
                            this.fancyboxInit();
                        });
                    });
                }
            },

            buttonTopAnimationEvents() {
                var stop   = false;
                var $btnUp = $('.photo-report__top');

                $btnUp.on('mouseenter', function() {
                    $(this).addClass('photo-report__top--anima');

                    stop = false;
                });

                $btnUp.on('mouseleave', function() {
                    stop = true;
                });

                $btnUp.on('animationiteration', function() {
                    if(stop) {
                        $(this).removeClass('photo-report__top--anima');
                    }
                });
            },

            scrollTop() {
                $('html').animate({
                    scrollTop: 0
                }, 500);
            },

            fancyboxInit() {
                $('[data-fancybox="gallery"]').fancybox({
                    // toolbar  : false,
                    btnTpl: {
                        close: '<button data-fancybox-close class="fancybox-button--close fancybox-button-close" title="{{CLOSE}}">' +
                        '<svg width="19px" height="18px" viewBox="0 0 19 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill-rule="evenodd"><g id="Мобилка/Меню-открыто" transform="translate(-338.000000, -36.000000)"><g id="Group-2" transform="translate(338.000000, 36.000000)"><rect id="Rectangle-Copy" transform="translate(9.500000, 9.000000) rotate(-45.000000) translate(-9.500000, -9.000000) " x="-2" y="8" width="23" height="2" rx="1"></rect><rect id="Rectangle-Copy" transform="translate(9.500000, 9.000000) rotate(-315.000000) translate(-9.500000, -9.000000) " x="-2" y="8" width="23" height="2" rx="1"></rect></g></g></g></svg>' +
                        '</button>',

                        arrowLeft:
                        '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
                        '<svg width="13px" height="23px" viewBox="0 0 13 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill-rule="evenodd"><g id="Главная-1" transform="translate(-1044.000000, -898.000000)"><path d="M1039.71371,914.913708 L1052.11371,914.913708 C1052.77645,914.913708 1053.31371,915.450967 1053.31371,916.113708 C1053.31371,916.77645 1052.77645,917.313708 1052.11371,917.313708 L1038.51371,917.313708 C1037.85097,917.313708 1037.31371,916.77645 1037.31371,916.113708 L1037.31371,902.513708 C1037.31371,901.850967 1037.85097,901.313708 1038.51371,901.313708 C1039.17645,901.313708 1039.71371,901.850967 1039.71371,902.513708 L1039.71371,914.913708 Z" id="Combined-Shape-Copy" transform="translate(1045.313708, 909.313708) scale(-1, 1) rotate(-315.000000) translate(-1045.313708, -909.313708) "></path></g></g></svg>' +
                        "</button>",

                        arrowRight:
                        '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
                        '<svg width="13px" height="23px" viewBox="0 0 13 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill-rule="evenodd"><g id="Главная-1" transform="translate(-1044.000000, -898.000000)"><path d="M1039.71371,914.913708 L1052.11371,914.913708 C1052.77645,914.913708 1053.31371,915.450967 1053.31371,916.113708 C1053.31371,916.77645 1052.77645,917.313708 1052.11371,917.313708 L1038.51371,917.313708 C1037.85097,917.313708 1037.31371,916.77645 1037.31371,916.113708 L1037.31371,902.513708 C1037.31371,901.850967 1037.85097,901.313708 1038.51371,901.313708 C1039.17645,901.313708 1039.71371,901.850967 1039.71371,902.513708 L1039.71371,914.913708 Z" id="Combined-Shape-Copy" transform="translate(1045.313708, 909.313708) scale(-1, 1) rotate(-315.000000) translate(-1045.313708, -909.313708) "></path></g></g></svg>' +
                        "</button>"
                    },
                    afterClose: () => {
                        $('.page__view').animate({
                            scrollTop: this.positionOnPage
                        }, 100);
                    },
                    beforeShow: () => {
                        this.positionOnPage = $('.page__view').scrollTop();
                    },
                    beforeClose: function () {
                        $('.fancybox-button-close').addClass('fancybox-button-close--hide');
                        $('.fancybox-navigation').addClass('fancybox-navigation--hide');
                    }
                });
            }
        }
    }
</script>
